import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import MenuItem from '../ui/menuitem';

const CardMenu = ({ title, description, list }: { title: string, description: string, list: Array<{ name: string; price: number; isrecommend?: boolean }> }) => {
    return (
        <div className='py-3'>
            <Card>
                <CardHeader>
                    <CardTitle className='font-cursive2 tracking-wider' style={{ fontSize: "1.7rem" }}>{title}</CardTitle>
                    <CardDescription style={{ fontSize: "0.8rem" }}>
                        {description}
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <div className="flex flex-col justify-between gap-1">
                        {
                            list.map((item: { name: string; price: number; isrecommend?: boolean; }, idx) => {
                                return (
                                    <div
                                        key={idx}
                                    >
                                        <MenuItem name={item.name} price={item.price} isrecommend={item.isrecommend} />
                                    </div>
                                    // <div key={idx}>
                                    //     <MenuItem name={item.name} price={item.price} isrecommend={item.isrecommend} />
                                    // </div>
                                )
                            })
                        }
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default CardMenu